import React, { useEffect } from 'react';
import styled from 'styled-components';
import { colors, layout } from 'Constants';

import { Container, Header, Icon, Anchor, Button } from 'Components/core';

import InfoBox from 'Components/InfoBox';
import ReadyToEnroll from 'Views/benefits/components/ReadyToEnroll';

// Images
import Accident from './images/Voluntary_Supplemental_-_Accident_benefits@2x.png';
import CriticalIllness from './images/critical@2x.png';
import HospitalIndemnity from './images/f24f50519ca30cd50d6f0f3d89b1e37f@2x.png';
import Footnote from 'Components/core/Footnote';
import { ApiStore } from 'Store';
import { Subscribe } from 'laco-react';
import Api from 'Root/libs/analytics/Api';
import CODES from 'Root/libs/analytics/CodeDef';
import { replaceAnchor } from 'Root/libs/anchor';
import { HeaderV2, SubHeader, TitleHeader } from 'Components/core/Header';
import PaddedContainer from 'Components/core/PaddedContainer';

const getSingleItemFromArray = val => {
  if (!val) return val;
  const arr = Array.isArray(val) ? val : val ? [val] : [];
  if (arr.length > 0) return arr[0];
  return ' ';
};

const SupplementBoxHeader = styled.div`
  font-family: 'Elevance Sans Semibold';
  font-weight: 600;
  font-size: 36px;
  line-height: 48px;
  text-align: left;
  color: #1a3673;
`;
const SupplementBoxImage = styled.img`
  width: 552px;
  height: 578px;
  border-radius: 8px;
  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    display: none;
  }
`;

const SupplementBoxImage2 = styled.img`
  display: none;
  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    display: block;
    width: 100%;
    height: auto;
    border-radius: 8px;
  }
`;

const SupplementBoxText = styled.div``;
const SupplementBoxContainer = styled.div`
  display: flex;
  margin-top: 20px;
  margin-bottom:40px ;
  @media screen and (max-width: ${layout.breakpoints.mobile}) {
  flex-wrap: wrap;
  }
`;

const SupplementBox = ({ image, children, header, imageAlign }) => {
  return (
    <SupplementBoxContainer>
      {imageAlign == 'left' ? <SupplementBoxImage src={image} /> : null}
      <Container
        style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 10 }}
        column
      >
        <SupplementBoxHeader>{header}</SupplementBoxHeader>
        <SupplementBoxText>{children}</SupplementBoxText>
      </Container>
      {imageAlign != 'left' ? <SupplementBoxImage src={image} /> : null}
      <SupplementBoxImage2 src={image} />
    </SupplementBoxContainer>
  );
};

export default () => {
  useEffect(() => {
    Api.recordAcitity(CODES.MENU_VSHB);
  }, []);

  return (
    <Subscribe to={[ApiStore]}>
      {state => (
        <Container column maxWidth style={{ margin: 'auto' }}>
          <HeaderV2 title={'Supplemental Health '}></HeaderV2>

          <PaddedContainer column>
            {state.voluntary?.importantNotice &&(
              <div style={{fontSize:14,marginTop:30}} dangerouslySetInnerHTML={{__html:state.voluntary?.importantNotice}}>
                
              </div>
            )}
            {state.voluntary?.accidentBenefits && (
              <SupplementBox
                header="Accident benefits"
                image={Accident}
                imageAlign="left"
              >
                {state.voluntary?.accidentBenefits !== true && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: replaceAnchor(state.voluntary?.accidentBenefits)
                    }}
                  ></div>
                )}
                {state.voluntary?.accidentBenefits === true && (
                  <React.Fragment>
                    {' '}
                    <p>
                      Accidents happen, and the costs can be overwhelming — even
                      with health benefits. That’s where accident protection can
                      help. These special plans pay out lump-sum cash benefits
                      if you or someone on your plan is injured because of an
                      accident. You decide how to use the benefits to best
                      support your recovery. You can use accident benefits to
                      help pay for medical costs or daily living expenses like
                      rent, food, transportation or help around the house.
                    </p>
                    <p>
                      <b>Key plan features:</b>
                      <ul>
                        <li> Lump-sum cash benefit is paid directly to you.</li>
                        <li>
                          {' '}
                          Auto alerts let you know you may have an eligible
                          claim.
                          <sup>1</sup>
                        </li>

                        <li> No medical questions or exam needed to enroll.</li>
                        <li>
                          You can take your benefits with you, even if you leave
                          your employer.<sup>2</sup>
                        </li>
                        <li>
                          {' '}
                          No limitations for pre-existing conditions.
                          <sup>3</sup>
                        </li>
                        <li>
                          Benefits are available for yourself, your spouse and
                          dependent children.
                        </li>
                      </ul>
                    </p>
                  </React.Fragment>
                )}
                <Footnote>
                  {state.voluntary?.accidentalBenefitsfootNotes && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: replaceAnchor(
                          getSingleItemFromArray(
                            state.voluntary?.accidentalBenefitsfootNotes
                          )
                        )
                      }}
                    ></div>
                  )}
                  {!state.voluntary?.accidentalBenefitsfootNotes && (
                    <React.Fragment>
                      1 Available when you have both medical and accident
                      benefits with your state plan.
                      <br />2 Not available in all states. Members can only
                      continue coverage while the policy is still active.The
                      member must pay premium if they elect to continue coverage
                      after leaving employer.
                      <br />3 Covered accidents must occur after the effective
                      date of coverage.
                      <br />
                      Group accident benefits provided by policy form SAI B XX18
                      P or state equivalent.
                      <br />
                    </React.Fragment>
                  )}
                </Footnote>
              </SupplementBox>
            )}
            {state.voluntary?.criticalIllness && (
              <SupplementBox
                header={state.ciTitle}
                image={CriticalIllness}
                imageAlign="right"
              >
                {state.voluntary?.criticalIllness !== true && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: replaceAnchor(state.voluntary?.criticalIllness)
                    }}
                  ></div>
                )}
                {state.voluntary?.criticalIllness === true && (
                  <React.Fragment>
                    <p>
                      You shouldn’t have to worry about how you’re going to pay
                      for care when you have a critical illness. Critical
                      Illness benefits provide the added layer of security you
                      want and need: a lump-sum cash benefit to help pay for
                      unexpected costs. You decide how to use the benefits to
                      best support recovery for yourself or someone on your
                      plan, such as:
                    </p>
                    <p>
                      <ul>
                        <li>
                          Out-of-pocket medical costs, like doctor bills,
                          imaging or rehab.
                        </li>
                        <li>
                          Daily expenses like rent, food, transportation, child
                          care or help around the house.
                        </li>
                      </ul>
                    </p>
                    <p>
                      Our Critical Illness plan provides benefits for heart
                      attack, stroke, invasive cancer, major organ transplant
                      and neurological conditions such as advanced Alzheimer’s
                      and advanced Parkinson’s. The benefits pay for the first
                      diagnosis of certain illnesses after your plan becomes
                      effective. Benefits may also cover a new cancer diagnosis,
                      even with a previous cancer diagnosis.<sup>1</sup>
                    </p>

                    <p>
                      <b>Key plan features:</b>
                      <ul>
                        <li>Lump-sum cash benefit is paid directly to you.</li>
                        <li>
                          Auto alerts let you know you may have an eligible
                          claim.
                          <sup>2</sup>
                        </li>

                        <li>
                          A $50 payment toward health screenings, such as a
                          lipid test. Simply call the claim line and tell them
                          you’d like to collect on your wellness benefits. We’ll
                          confirm your testing, then send you a check.
                        </li>
                        <li>
                          No limitations on pre-existing conditions.<sup>3</sup>
                        </li>
                        <li>
                          Benefits are available for yourself, your spouse and
                          dependent children.
                        </li>
                        <li>
                          You can take your benefits with you, even if you leave
                          your employer.<sup>4</sup>
                        </li>
                      </ul>
                    </p>
                  </React.Fragment>
                )}
                <Footnote>
                  {state.voluntary?.criticalIllnessfootNotes && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: replaceAnchor(
                          getSingleItemFromArray(
                            state.voluntary?.criticalIllnessfootNotes
                          )
                        )
                      }}
                    ></div>
                  )}
                  {!state.voluntary?.criticalIllnessfootNotes && (
                    <React.Fragment>
                      1 Restrictions may apply.
                      <br />2 Available when you have both medical and Critical
                      Illness benefits with your state plan.
                      <br />3 Covered accidents or illness must occur after the
                      effective date of coverage.
                      <br />4 Not available in all states. Members can only
                      continue coverage while the policy is still active. The
                      member must pay premium if they elect to continue coverage
                      after leaving employer.
                      <br />
                      Group Critical Illness benefits provided by policy form
                      SAI B XX18 P or state equivalent.
                      <br />
                    </React.Fragment>
                  )}
                </Footnote>
              </SupplementBox>
            )}
            {state.voluntary?.hospitalIndemnity && (
              <SupplementBox
                header="Hospital Indemnity benefits"
                image={HospitalIndemnity}
                imageAlign="left"
              >
                {state.voluntary?.hospitalIndemnity !== true && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: replaceAnchor(state.voluntary?.hospitalIndemnity)
                    }}
                  ></div>
                )}
                {state.voluntary?.hospitalIndemnity === true && (
                  <React.Fragment>
                    <p>
                      Your medical plan covers some of the costs of a hospital
                      stay, but you can expect to pay some of the costs out of
                      pocket. Protect yourself from these expenses with Hospital
                      Indemnity insurance. Think of Hospital Indemnity as a bit
                      of financial assistance when you need it most. It provides
                      a lump-sum, tax-free cash benefit to help pay for hospital
                      costs, medical tests or rehab that your health plan
                      doesn’t cover. Or you could use it to help pay for daily
                      expenses like rent, food, transportation, child care or
                      help around the house.
                    </p>

                    <p>
                      <b>Key plan features:</b>
                      <ul>
                        <li>
                          Covers hospitalization for normal pregnancy from day
                          one with no waiting period.
                        </li>
                        <li>
                          Auto alerts let you know you may have an eligible
                          claim.
                          <sup>1</sup>
                        </li>
                        <li>
                          No limitations for pre-existing conditions.
                          <sup>2</sup>
                        </li>
                        <li>No medical questions or exam needed to enroll.</li>
                        <li>
                          You can take your benefits with you and keep the same
                          rate if you leave your employer, for up to three
                          years.
                          <sup>3</sup>
                        </li>
                        <li>
                          Benefits are available for yourself, your spouse and
                          dependent children.
                        </li>
                      </ul>
                    </p>
                  </React.Fragment>
                )}
                <Footnote>
                  {state.voluntary?.hospitalIndemnityfootNotes && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: replaceAnchor(
                          getSingleItemFromArray(
                            state.voluntary?.hospitalIndemnityfootNotes
                          )
                        )
                      }}
                    ></div>
                  )}
                  {!state.voluntary?.hospitalIndemnityfootNotes && (
                    <React.Fragment>
                      1 Restrictions may apply.
                      <br />2 Available when you have both medical and Critical
                      Illness benefits with your state plan.
                      <br />3 Covered accidents or illness must occur after the
                      effective date of coverage.
                      <br />4 Not available in all states. Members can only
                      continue coverage while the policy is still active. The
                      member must pay premium if they elect to continue coverage
                      after leaving employer.
                      <br />
                      Group Critical Illness benefits provided by policy form
                      SAI B XX18 P or state equivalent.
                      <br />
                    </React.Fragment>
                  )}
                </Footnote>
              </SupplementBox>
            )}
            <ReadyToEnroll />
          </PaddedContainer>
        </Container>
      )}
    </Subscribe>
  );
};
